import React from 'react';
import propTypes from 'prop-types';
import { fileManagementApi } from '../../../services/apis';
import './fileUpload.scss';
const FileUpload = ({
  tabIndex = 0,
  recieveFile = () => {},
  giveFeedBack = () => {},
  isOptional,
  fileAccepted,
  title,
  className = 'bg-secondary text-white',
  disabled = false,
  customClassName,
}) => {
  return (
    <div
      className={`${
        customClassName ? customClassName : 'justify-content-center py-2 px-4'
      } w-100 d-flex  font-small ${
        disabled ? 'fileUpload-disabled' : 'cursor-pointer'
      } fileUpload  ${className} `}
      tabIndex={tabIndex}
    >
      <input
        className="upload"
        onChange={async (event) => {
          giveFeedBack({ loadingData: true });
          const formData = new FormData();
          formData.append(
            'file',
            event.target.files[0],
            event.target.files[0].name,
          );

          // Send the file to the server
          try {
            const {
              status,
              payload: { data },
            } = await fileManagementApi.upload(formData);
            if (status === 200) recieveFile(data?.filename);
          } catch {
            recieveFile(null);
          } finally {
            giveFeedBack({ loadingData: false });
          }
        }}
        type="file"
        accept={fileAccepted}
        required={!isOptional}
        disabled={disabled}
      />
      <span className="d-flex align-items-center">{title}</span>
    </div>
  );
};

FileUpload.propTypes = {
  isOptional: propTypes.bool,
  title: propTypes.oneOfType([propTypes.string, propTypes.object]),
  customClassName: propTypes.string,
  fileAccepted: propTypes.string,
  recieveFile: propTypes.func,
};
FileUpload.defaultProps = {
  isOptional: true,
  customClassName: '',
  title: 'Upload File',
  fileAccepted: 'image/*',
  recieveFile: () => {},
};

export default FileUpload;
